import { InjectionToken } from '@angular/core';

export interface FreshdeskWebwidgetConfig {
  widgetId: number;
}

export const FreshdeskWebwidgetConfigToken =
  new InjectionToken<FreshdeskWebwidgetConfig>('FreshdeskWebwidgetConfig');
